import SkinnerBoxFAB from "@components/features/SkinnerBox/SkinnerBoxFAB";
import { PropsWithClassName, cn } from "kz-ui-sdk";

interface SkinnerBoxProps extends PropsWithClassName {
  claimableAmount: number;
  onLeaveAnimationCompleted?: () => void;
  fabClassName?: string;
}

const SkinnerBox = ({ className, claimableAmount, onLeaveAnimationCompleted, fabClassName }: SkinnerBoxProps) => {
  return (
    <div className={cn(className)}>
      <SkinnerBoxFAB
        className={cn("me-1 animate-fade-in", fabClassName)}
        aria-label="Skinner Box FAB"
        zIndex={20}
        claimableAmount={claimableAmount}
        onLeaveAnimationCompleted={onLeaveAnimationCompleted}
      />
    </div>
  );
};

export default SkinnerBox;
